export default "__VITE_ASSET__b35adf0c__"